
import PropTypes from 'prop-types';

export default PropTypes.shape({
  scopes: PropTypes.arrayOf(PropTypes.string),
  myEmployeeId: PropTypes.number,
  email: PropTypes.string
})